<template>
  <div
    id="inbox-container"
    class="container-fluid"
  >
    <div class="row">
      <div class="col-md-4">
        <request-list-view
          :requests="mutableRequests"
          :active-request="activeRequest"
          @activate="activateRequest"
        />
      </div>
      <div class="col-md-8">
        <messaging
          v-if="activeRequest"
          :request="activeRequest"
          @updateRequest="onUpdateRequest"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RequestListView from './request-box/requestList.vue';
import Messaging from './request-box/messaging.vue';
// import DocumentRequestModel from '../../models/documentRequest';

export default {
  components: {
    // DocumentRequestModel,
    RequestListView,
    Messaging,
  },

  props: {
    requests: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      activeRequest: null,
      mutableRequests: this.requests,
    };
  },

  mounted() {
    if (this.activeRequest === null) {
      this.selectDefaultRequest();
    }
  },

  methods: {
    activateRequest(requestId) {
      this.activeRequest = this.mutableRequests.find((request) => request.id === requestId);
    },

    selectDefaultRequest() {
      [this.activeRequest] = this.mutableRequests;
    },

    onUpdateRequest(request) {
      // Find the index of the returned request.
      const index = this.mutableRequests.findIndex((iRequest) => iRequest.id === request.id);

      if (index === -1) {
        return;
      }

      this.mutableRequests.splice(index, 1, request);

      // Override the active request if if is the one in the
      // response (which it probably will be)
      if (this.activeRequest && this.activeRequest.id === request.id) {
        this.activeRequest = request;
      }

      this.$emit('updated');
    },
  },
};
</script>
